import { staticFile } from '@common/utils'
import NextImage, {
  ImageLoader,
  ImageProps as NextImageProps,
} from 'next/image'

const fastlyIOLoader: ImageLoader = ({ src, width, quality }) => {
  let url =
    staticFile(src) + `?auto=webp&optimize=medium&width=${width.toFixed(0)}`
  if (quality) url += `quality=${quality.toFixed(0)}`
  return url
}

/** Fetches images via Fastly IO */
const FastlyImage = (props: NextImageProps) => (
  <NextImage {...props} loader={fastlyIOLoader} />
)

export default FastlyImage
